angular.module('leanlaw').controller('CustomReportCtrl', ['$scope', '$rootScope', '$state', '$window', '$filter', "alerts", 'userService', 'reportsService', 'lists', "exportJson", "singleRequest", "messageBus", function ($scope, $rootScope, $state, $window, $filter, alerts, userService, reportsService, lists, exportJson, singleRequest, messageBus) {
  $scope.data = {};
  $scope.filter = {};
  $scope.search = "";
  $scope.format = {};
  $scope.sort = 'user.name';
  $scope.reverse = false;
  $scope.print = function () {
    $window.print();
  };
  $scope.export = function () {
    const term = $scope.me.terms.Custom1;
    const title = $scope.filter.accountFilter.label;
    const exp = $scope.data.filtered.map(user => ({
      [title]: user.user.name,
      [term]: user.data.custom.custom1.average
    }));
    exportJson.downloadCsv(exp);
  };
  $scope.detail = function (user) {
    $state.go('reports.custom-detail', {
      userId: user.id
    });
  };
  activate();

  ///////////////////

  async function activate() {
    // Note: even though we are not using 'me' it should still be loaded to ensure that
    // the lists are updated correctly (me() replaces certain terms in lists.matterRoles)
    $scope.me = await userService.me();
    $scope.filter.accountFilter = {
      id: 'primary',
      label: `${$scope.me.terms.Primary} ${$scope.me.terms.Lead}`
    };
    $scope.$on('commonFilterService-statechanged', (event, payload) => {
      if (!payload) return;
      // Assigning to existing filter keeps custom filter options
      $scope.filter = Object.assign($scope.filter, payload);
      // Necessary to set this value for the requests
      $scope.filter.status = $scope.filter.archived.status;
      $scope.filter.scope = $scope.filter.filter.scope;
      // if (payload.filter.range) filterClientEntries();
      filterEntries();
    });
    $rootScope.$on("report-sidebar-filterchange", (event, payload) => {
      $scope.filter = Object.assign($scope.filter, payload);
      filterEntries();
    });

    // MessageBus is used here so that the commonFilter module can pick it up once it loads
    messageBus.addMessage("filterDependency-ready", true);
  }
  async function filterEntries() {
    $scope.loading = true;
    const query = reportsService.queryFromFilter($scope.filter);
    query.data = "custom";
    query.primary = "users";
    query.accountFilter = $scope.filter.accountFilter && $scope.filter.accountFilter.id;
    const report = await singleRequest.serviceCall("reports", reportsService.getReport)(query);
    if (!report) return;
    $scope.data.report = report;
    $scope.loading = false;
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("reports");
    deactivate();
  });

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.data || !$scope.data.report) return;
    $scope.data.filtered = $filter('orderBy')($filter('filter')($scope.data.report.users, $scope.search), $scope.sort, $scope.reverse) || [];
  }
  $scope.$watch('data.report.users', updateFiltered);
  $scope.$watch('search', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);